<template>
  <div class="accordion">
    <b-card no-body>
      <b-card-header header-tag="header" role="tab">
        <b-button block v-b-toggle.accordion-collapse-idiotites class="accordion-button fonts-global">
          <span class="asterisk">*</span> {{ title }}
          <span class="when-opened float-right">
            <b-icon-dash-square-fill class="pr-1"></b-icon-dash-square-fill>
          </span>
          <span class="when-closed float-right">
            <b-icon-plus-square-fill class="pr-1"></b-icon-plus-square-fill>
          </span>
        </b-button>
      </b-card-header>
      <b-collapse style="background-color:white" id="accordion-collapse-idiotites" visible>
        <div style="margin:10px">
          <slot name="table"></slot>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>

export default {
  name: "BaseAccordion",
  props: {
    title: {
      default: '',
      require: false,
      type: String
    },
  }
}
</script>

<style scoped>

.asterisk {
  content: "*";
  color: red;
  margin-right: 4px;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
  justify-content: space-between;
}

.accordion-button {
  text-align: left;
  background-color: #f5f5f5;
  border-color: #f5f5f5;;
}

.accordion {
  margin-bottom: 0px;
  border-width: 0px;
}

.accordion > .card {
  overflow: hidden;
  border-color: #f5f5f5;
  padding: 0px;
  margin: 0px;
  background-color: #f5f5f5;
  border-width: 0px 2px 2px 2px;
}

.accordion > .card > .card-header {
  border-radius: 0;
  border-width: 0px;
  border-color: transparent;
  padding: 2px;
  margin: 0px;
  background-color: #f5f5f5;
}

.accordion-button-light {
  margin-right: 10px !important;
}

/*.btn.disabled, .btn:disabled {*/
/*  opacity: 0.65;*/
/*  background-color: #ffffff;*/
/*  border-color: #ddd;*/
/*}*/
</style>
